import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';
import { Box, createBox } from '@famly/mf_layout_box';
import { Button } from '@famly/mf_input_button';
import { LoginFormTextField } from 'web-app/react/login/shared-components';
import translate from 'signin-app/helpers/translate';
import { useWhitelabelConfiguration } from 'signin-app/whitelabel/use-whitelabel-configuration';
import { PasswordTooltip } from './password-tooltip';
import { loginFormResolver } from './login-form-resolver';
const StyledLoginFormTextField = styled(LoginFormTextField) `
    color: ${props => props.theme.invertedText};
    height: 43px;
    padding-right: 36px; /* To accommodate the password hint button */
    &&&::placeholder {
        color: ${props => props.theme.invertedTextSecondary};
    }
`;
const FormFieldWrapper = styled.div `
    position: relative;
`;
/**
 * The MF Button does not expose the login page's whitelabel look (white background,
 * primary-colour text, larger font), so we style the rendered button element here.
 */
const SubmitButtonContainer = styled(createBox({})) `
    &&& button {
        font-size: 20px;
        font-weight: 500;
        background-color: ${props => props.theme.mf.colorPalette.n0};
        color: ${props => props.$primaryColor};
    }
`;
const initialValues = {
    password: '',
};
const LoginForm = ({ onSubmit }) => {
    const whitelabelConfiguration = useWhitelabelConfiguration();
    const { control, handleSubmit } = useForm({
        defaultValues: initialValues,
        resolver: loginFormResolver,
    });
    return (_jsxs(Box, { component: "form", id: "loginForm", onSubmit: handleSubmit(async (values) => onSubmit(values)), width: "264px", children: [_jsxs(FormFieldWrapper, { children: [_jsx(Controller, { control: control, name: "password", render: ({ field: { name, value, onChange, onBlur }, fieldState }) => {
                            var _a;
                            return (_jsx(StyledLoginFormTextField, { input: { name, value, onChange, onBlur }, meta: { touched: Boolean(fieldState.error), error: (_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message }, id: "password", type: "password", placeholder: translate('passwordPlaceholder'), "aria-label": translate('passwordPlaceholder'), autoComplete: "signin-password", activeColor: "invertedText", passiveColor: "invertedTextDisabled" }));
                        } }), _jsx(PasswordTooltip, {})] }), _jsx(SubmitButtonContainer, { "$primaryColor": whitelabelConfiguration.PrimaryColor, mt: 6, children: _jsx(Button, { type: "submit", variant: "primary", fullWidth: true, text: translate('logIn'), "data-e2e-id": "signin-login-button" }) })] }));
};
export default LoginForm;
